import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '@/api/common.ts'
import { z } from 'zod'

export const Inv1015SearchParamsSchema = z
  .object({
    number: z.string().optional(),
    refNo: z.string().optional(),
    dateFrom: z.coerce.date().optional(),
    dateTo: z.coerce.date().optional(),
    status: z
      .union([z.literal('1'), z.literal('2'), z.literal('3'), z.literal('4')])
      .optional(),
    filterStatus: z.string().optional(),
  })
  .merge(BasePaginateParamsSchema)

export type Inv1015SearchParams = z.infer<typeof Inv1015SearchParamsSchema>

export const Inv1015SearchResultModelSchema = z.object({
  id: z.number(),
  number: z.string(),
  partyId: z.number().nullable(),
  refNo: z.string(),
  date: z.coerce.date(),
  status: z
    .union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)])
    .optional(),
  filterStatus: z.string().optional(),
})

export type Inv1015SearchResultModel = z.infer<
  typeof Inv1015SearchResultModelSchema
>

export const Inv1015SearchResultSchema = z
  .object({
    data: z.array(Inv1015SearchResultModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type Inv1015SearchResult = z.infer<typeof Inv1015SearchResultSchema>
